export default __webpack_public_path__ + "static/media/horsch.71562a80.png";